import { render, staticRenderFns } from "./ProviderOfferings.vue?vue&type=template&id=0c73d014&scoped=true&"
import script from "./ProviderOfferings.vue?vue&type=script&lang=ts&"
export * from "./ProviderOfferings.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderOfferings.vue?vue&type=style&index=0&id=0c73d014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c73d014",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VCol,VContainer,VLayout,VRow,VThemeProvider})
